import DeleteIcon from '@mui/icons-material/Delete'
import { IconButton } from '@mui/material'
import React from 'react'

interface IDeleteProps {
  data: any
  onDelete: (data: any) => void
}

const DeleteCellRenderer: React.FC<IDeleteProps> = ({
  data,
  onDelete,
}: IDeleteProps) => {
  return (
    <IconButton onClick={() => onDelete(data)} aria-label='delete' size='small'>
      <DeleteIcon />
    </IconButton>
  )
}

export default DeleteCellRenderer
